import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['focus', 'panel']
  static values = {
    id: String,
  }

  connect() {
    this.focusTarget.focus()

    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('mousedown', this.boundHandleClickOutside)
    document.addEventListener('keydown', this.boundHandleKeydown)

    this.setupPanel()

    requestAnimationFrame(() => {
      this.panelTarget.classList.add(
        'transition-transform',
        'duration-500',
        'ease-in-out'
      )
      this.showPanel()
    })
  }

  disconnect() {
    document.removeEventListener('mousedown', this.boundHandleClickOutside)
    document.removeEventListener('keydown', this.boundHandleKeydown)
  }

  setupPanel() {
    const panel = this.panelTarget

    panel.classList.remove(
      'translate-x-full',
      '-translate-x-full',
      'left-0',
      'right-0'
    )
    panel.classList.remove(
      'transition-transform',
      'duration-500',
      'ease-in-out'
    )

    panel.classList.add('right-0')
    panel.classList.add('translate-x-full')
  }

  showPanel() {
    this.panelTarget.classList.remove('translate-x-full', '-translate-x-full')
  }

  handleClickOutside(event) {
    // 오버레이 배경 클릭 감지: 패널 밖을 클릭했고, 오버레이 또는 그 자식 요소인 경우
    const isClickOnOverlay = !this.panelTarget.contains(event.target)

    if (isClickOnOverlay) {
      this.hide(event)
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.hide(event)
    }
  }

  hide(event) {
    if (event) {
      event.preventDefault()
    }

    this.panelTarget.classList.add(
      'transition-transform',
      'duration-500',
      'ease-in-out'
    )
    this.panelTarget.classList.add('translate-x-full')

    // 애니메이션 완료 후 turbo_frame 내용을 비우기 (제거하지 않음)
    setTimeout(() => {
      const turboFrame = document.getElementById('side_panel_content')
      if (turboFrame) {
        turboFrame.innerHTML = ''
        turboFrame.setAttribute('src', '')
      }
    }, 500)
  }

  hideOnSubmit(event) {
    // 댓글 및 작업물 등록 form submit은 패널을 닫지 않음
    const formElement = event.target
    if (formElement && formElement.action) {
      const shouldKeepOpen =
        formElement.action.includes('/comments') ||
        formElement.action.includes('/deliverables')
      if (shouldKeepOpen) {
        return
      }
    }

    if (event.detail.success) {
      this.hide(event)
    }
  }
}
